// extracted by mini-css-extract-plugin
export default {"AddEnemy":"AddEnemy_AddEnemy__yjFrO","form":"AddEnemy_form__VoluL"};